<template>
  <v-container>
    <h2 class="display-1 pb-3" style="color: #084776">{{ stavke.title }}</h2>
    <v-row class="pt-4">
      <v-col cols="6" md="3">
        <p class="grey--text font-italic">
          <v-icon color="#084776" small class="pr-1">far fa-user</v-icon>
          {{ stavke.author }}
        </p>
      </v-col>
      <v-col cols="6" md="3">
        <p class="grey--text font-italic">
          <v-icon color="#084776" small class="pr-1">far fa-calendar-alt</v-icon>
          {{ stavke.date_diff }}
        </p>
      </v-col>
      <v-col cols="4" md="3">
        <p class="grey--text font-italic">
          <v-icon color="#084776" small class="pr-1">far fa-eye</v-icon>
          {{ stavke.views }}
        </p>
      </v-col>
    </v-row>
    <div v-for="(i, x) in stavke.images" :key="x">
      <v-img v-if="x==0" :src="'https://web-admin.sum.ba/api/storage/' + i"></v-img>
    </div>
    <v-row class="pt-4">
      <v-col cols="12" md="8">
        <h2 class="grey--text pb-3">{{ stavke.subtitle }}</h2>
        <p v-html="stavke.content"></p>
        <p class="grey--text pt-4">Datum objave: {{ stavke.created_at }}</p>
        <div v-if="stavke.video">
          <iframe width="100%" height="315"
                  :src="'https://www.youtube.com/embed/' + obavijest.video.slice(32, obavijest.video.length)"
                  frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen></iframe>
        </div>
        <div>
          <gallery :images="lista_slika" :index="index" @close="index = null"></gallery>
          <v-row>
            <v-col cols="6" sm="4" md="3" xl="3" v-for="(image, imageIndex) in stavke.images" :key="imageIndex">
              <div
                  class="image"


                  @click="index = imageIndex"
                  :style="{ backgroundImage: 'url(' + 'https://web-admin.sum.ba/api/storage/' + image + ')', width: '178px', height: '120px' }"
              ></div>
            </v-col>
          </v-row>
        </div>
      </v-col>


      <v-col cols="12" md="4">
        <v-card
            flat
            style="border: 1px solid #084776; border-style: solid;
                    border-color: coral;
                    border-color: #084776;
                    "
        >
          <v-row style="margin:-1px; width:100%">
            <div class="triangle_red_small">
              <v-img
                  :src="require('@/assets/img/sum-icon.svg')"
                  style="width: 50px; position: absolute; top: 27px; left: 10px;"
              ></v-img>
            </div>
            <v-spacer></v-spacer>
            <div style="margin-right: 10px">
              <p
                  class="meni_txt"
                  style="text-align: right; color:#084776; margin-top: 5px;"

              > NOVOSTI<br>NA SUM-u</p>
            </div>
          </v-row>
          <v-card-title style="width: 100%; margin-top: -50px">
            <v-list two-line class="pa-0" style="width: 100%; margin-top: 0px;">
              <div v-for="(novost, i) in novosti" :key="i">
                <v-divider
                    color="#084776"
                    style="margin-right: 10px; margin-left: 10px;"
                    v-if="i != 0"
                ></v-divider>
                <v-list-item>
                  <a class="link" style="font-size: 16px" :href="'https://www.sum.ba/objave/novosti/' + novost.alias"
                     target="_blank">{{ novost.title }}</a>

                </v-list-item>
                <p class="grey--text ml-3" style="font-size: 15px">
                  <v-icon color="#084776" small class="pr-1">far fa-calendar-alt</v-icon>
                  {{ novost.date_diff }}
                </p>
              </div>

            </v-list>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import {serverBus} from "../main";
import VueGallery from "vue-gallery";

export default {
  async mounted() {
    serverBus.$emit("news-change", this.$route.params.alias);
    this.alias = this.$route.params.alias;
    this.getNovost();
    this.getSUMnovosti();
  },
  components: {
    gallery: VueGallery
  },
  methods: {
    getNovost() {
      let requestBody = {
        alias: this.alias
      };

      axios
          .post("https://web-admin.sum.ba/api/web/objava", requestBody)
          .then(response => {
            this.stavke = response.data;
            for (let i = 0; i < this.stavke.images.length; i++) {
              this.lista_slika.push(
                  "https://web-admin.sum.ba/api/storage/" + this.stavke.images[i]
              );
            }
          })
          .catch(error => console.log(error.message));
    },
    async getSUMnovosti() {
      let requestBody = {
        page: 1,
        postsPerPage: 3,
        alias: "novosti"
      };

      axios
          .post("https://web-admin.sum.ba/api/web/objave", requestBody)
          .then(response => {
            this.novosti = response.data;
            // console.log(this.istaknute_novosti);
          })
          .catch(error => console.log(error.message));
    },
  },
  data: () => ({
    stavke: [],
    novosti: [],
    lista_slika: [],
    index: null,
  })
}
</script>

<style scoped>
.image {
  float: left;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  border: 1px solid #ebebeb;
  margin: 5px;
}

.tamna * {
  background-color: black !important;
  color: white !important;
  padding: 0;
}
</style> 

